import { Tooltip } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";

import promotionStore from "../stores/promotionStore";

type DiscountLabelProps = {
   sku: string;
};

const DiscountLabel = observer(({ sku }: DiscountLabelProps) => {
   const applicablePromotions = promotionStore.getPromotionsBySku(sku);

   return applicablePromotions.map((promotion) => (
      <div key={promotion.id} className="flex">
         <div
            className={`rounded px-2 py-1 text-xxs ${promotion.applicable ? "bg-promotion text-base-0" : "bg-base-100 text-base-600"}`}
         >
            {promotion.banner}
         </div>
         {!promotion.applicable && <Tooltip tooltipText={promotion.inapplicableReason ?? ""} tooltipPosition="top" />}
      </div>
   ));
});

export default DiscountLabel;
